import { Injectable } from "@angular/core";
import * as jwt_decode from 'jwt-decode';
import { IUser } from "../_interface/user";


export interface JWTPayload {
  exp?: number;
  user: string;
  // other claims if needed
}


@Injectable({
  providedIn: 'root'
})
export class JwtHelperService {


  isTokenExpired(token: string): boolean {
    try {
      const decoded = jwt_decode.jwtDecode<JWTPayload>(token);
      if (!decoded.exp) return true;
      const now = Math.floor(Date.now() / 1000);
      return decoded.exp < now;
    } catch {
      return true;
    }
  }

  decodeToken(token: string) {
    try {
      return jwt_decode.jwtDecode<JWTPayload>(token);
    } catch (error) {
      console.error('Error decoding token:', error);
      return null;
    }
  }

}
